import { useSelector } from "react-redux";
import { getOptionEntries, getProductSku, getProductDisplayName } from "../Templates/quoteCalculator";

const HigherOrderComponent = (WrappedComponent) => {
  return (props) => {
    const Nvr = useSelector((state) => state.counter1.selectedNVR);
    const camera = useSelector((state) => state.counter1.selectedCamera);
    const cabling = useSelector((state) => state.counter1.selectedCabling);
    const labor = useSelector((state) => state.counter1.selectedLabor);
    const poe = useSelector((state) => state.counter1.selectedPoE);
    const hard = useSelector((state) => state.counter1.selectedHardWare);
    const special = useSelector((state) => state.counter1.selectedSpecial);
    const NumberOfOptions = useSelector((state) => state.counter1.totalOptions);
    const whichOption = useSelector(
      (state) => state.counter1.whichOptionSelected
    );
    const selectedCameraNumber = useSelector(
      (state) => state.counter1.totalCamera
    );

    const normalizeOptionValue = (value) => {
      if (value === undefined || value === null || value === "") return "";
      if (typeof value === "object") {
        return value.name || value.Name || value.label || value.value || "";
      }
      return value;
    };

    const OPTION_EXPORT_STANDARD_FIELDS = new Set([
      "id",
      "sku",
      "option",
      "num_options",
      "category",
      "category_name",
      "name",
      "Name",
      "Product_Name",
      "Product_Description",
      "Product_Quantity",
      "quantity",
      "Product_Base_Price",
      "Product_FinalPrice",
      "Product_Final_Price",
      "unitprice",
      "unit_price",
      "price",
      "price_2",
      "pricePerItem",
      "totalPriceForItem",
      "basePrice",
      "typedValue",
      "uniqueID",
      "type",
      "thumbnail",
      "image",
      "image1",
      "image2",
      "image3",
      "image4",
      "page",
      "drop",
      "extra_field_2",
      "extra_field_4",
      "hide_1",
      "hide_2",
      "sorting",
      "description",
      "categories",
      "Camera_Final_Price",
      "Camera_Base_Price",
      "Camera_Quantity",
      "Port_Final_Price",
      "Port_Base_Price",
      "Port_Quantity",
      "HardWare_Base_Price",
      "basePrice3",
      "Hardware_Total_data",
      "existingQuantity",
      "existingUnitCost",
      "existingTotalPrice",
      "Extra_Field",
      "num_poe_ports",
      "cableColor",
      "cableColorPrice",

      // PoE internal fields
      "Port_Name",
      "Port",
      "Port_Base_Price",
      "Port_Base",
      "Port_Quantity",
      "Port_Quantity_price",
      "poeFinalPrice",
      "poeFinal",
      "Poe Final Price",
      "Poe Final",
      "myUnitPrice",
      "myUnit",
      "My Unit Price",
      "My Unit",

      // Hardware internal fields
      "HardWare_Final_Price",
      "HardWare_Final",
      "Hardware Final Price",
      "Hardware Final",
      "Hardware_New_Final_Price",
      "Hardware_New_Final",
      "Hardware New Final Price",
      "Hardware New Final",
      "test",
      "Test",

      // Special/internal category fields
      "Camera_Category_Name",
    ]);

    const addOptionSlots = (newItem, selectedItem, startIndex = 1) => {
      let optionIndex = startIndex;
      const seen = new Set();

      const addOption = (name, value, price) => {
        const normalizedValue = normalizeOptionValue(value);
        if (!name || normalizedValue === "") return;
        if (OPTION_EXPORT_STANDARD_FIELDS.has(name)) return;
        if (HIDDEN_OPTION_NAMES.has(name)) return;
        if (/^option\d+(_name|_value|_price)?$/.test(name)) return;

        const signature = `${name}::${normalizedValue}`;
        if (seen.has(signature)) return;
        seen.add(signature);

        newItem[`option${optionIndex}_name`] = name;
        newItem[`option${optionIndex}_value`] = normalizedValue;
        newItem[`option${optionIndex}_price`] = Number(price || 0);
        optionIndex += 1;
      };

      // First handle already-normalized option slots if the category created them.
      for (let i = 1; i <= 12; i += 1) {
        if (selectedItem?.[`option${i}_name`] && selectedItem?.[`option${i}_value`]) {
          addOption(
            selectedItem[`option${i}_name`],
            selectedItem[`option${i}_value`],
            selectedItem[`option${i}_price`]
          );
        }
      }

      // Then handle the universal dropdown shape: "Caption" + "Caption_price".
      Object.keys(selectedItem || {}).forEach((key) => {
        if (!key.endsWith("_price") && !key.endsWith("Price")) return;

        const baseKey = key.endsWith("_price")
          ? key.slice(0, -6)
          : key.slice(0, -5);

        if (OPTION_EXPORT_STANDARD_FIELDS.has(baseKey)) return;
        if (/^option\d+$/.test(baseKey)) return;

        const value = selectedItem[baseKey];
        if (value === undefined || value === null || value === "") return;
        if (typeof value === "object") return;

        addOption(baseKey, value, selectedItem[key]);
      });

      // Last, use the calculator parser as a catch-all for any remaining clean pairs.
      getOptionEntries(selectedItem, Array.from(OPTION_EXPORT_STANDARD_FIELDS)).forEach(
        (option) => {
          addOption(option.name, option.value, option.price);
        }
      );

      return newItem;
    };

    const HIDDEN_OPTION_NAMES = new Set([
      "Port Name",
      "Port",
      "Poe Final Price",
      "Poe Final",
      "My Unit Price",
      "My Unit",
      "Hardware Final Price",
      "Hardware Final",
      "Hardware New Final Price",
      "Hardware New Final",
      "Test",
      "Camera Category Name",
    ]);

    const newHardware = hard;
    console.log("Redux State:", {
      Nvr,
      camera,
      cabling,
      labor,
      poe,
      hard,
      special,
      NumberOfOptions,
    });

    const filteredNvr2 = [];

    Nvr.map((selectedItem) => {
      let newItem = {
        option_cameras_selected: selectedCameraNumber,
        licenses: selectedItem["Number of IP Licenses"],
        num_poe_ports: "",
        option: selectedItem.num_options,
        page: "nvr",
        unitprice: selectedItem?.unitPrice,
        category: selectedItem.categories,
        Product_Name: getProductSku(selectedItem),
        Name: getProductDisplayName(selectedItem),
        Product_Quantity: selectedItem.Product_Quantity,
        Product_Base_Price: selectedItem.Product_Base_Price,
        Product_Final_Price: selectedItem.Product_Final_Price,
        image:
          selectedItem?.thumbnail ||
          selectedItem?.image1 ||
          selectedItem?.image2 ||
          selectedItem?.image3 ||
          "",
        option1_name: "CPU",
        option1_value: selectedItem.CPU,
        option1_price: selectedItem.CPU_price,
        option2_name: "RAM",
        option2_value: selectedItem.RAM,
        option2_price: selectedItem.RAM_price,
        option3_name: "M2 Drive (OS Drive)",
        option3_value: selectedItem["M2 Drive (OS Drive)"],
        option3_price: selectedItem["M2 Drive (OS Drive)_price"],
        option4_name: "Number of IP Licenses",
        option4_value: selectedItem["Number of IP Licenses"],
        option4_price: selectedItem["Number of IP Licenses_price"],
        option5_name: "Hard Drive Size",
        option5_value: selectedItem["Hard Drive Size"],
        option5_price: selectedItem["Hard Drive Size_price"],
      };

      if (selectedItem.drop) {
        newItem = { ...newItem, drop: selectedItem.drop };
      }

      filteredNvr2.push(newItem);
    });

    const csvCamera = [];
    camera.map((selectedItem) => {
      let optionName1;
      let optionValue1;
      let optionPrice1;
      let optionName3;
      let optionValue3;
      let optionPrice3;
      if (selectedItem["Edge Backup Recording"]) {
        optionName1 = "Edge Backup Recording";
        optionValue1 = selectedItem["Edge Backup Recording"];
        optionPrice1 = selectedItem["Edge Backup Recording_price"];
      } else if (selectedItem["Audio"]) {
        optionName1 = "Audio";
        optionValue1 = selectedItem["Audio"];
        optionPrice1 = selectedItem["Audio_price"];
      }
      if (selectedItem["Color"]) {
        optionName3 = "Color";
        optionValue3 = selectedItem["Color"];
        optionPrice3 = selectedItem["Color_price"];
      }

      let newItem = {
        option: selectedItem.num_options,
        page: "cameras",
        category: "Camera",
        unitprice: selectedItem?.unitprice,
        Product_Name: getProductSku(selectedItem),
        Name: getProductDisplayName(selectedItem),
        Product_Quantity: selectedItem.Product_Quantity,
        Product_Base_Price: selectedItem.Product_Base_Price,
        Product_Final_Price:
          selectedItem.Product_FinalPrice * selectedItem.Product_Quantity,
        image:
          selectedItem?.thumbnail ||
          selectedItem?.image1 ||
          selectedItem?.image2 ||
          selectedItem?.image3 ||
          "",
        option1_name: optionName1,
        option1_value: optionValue1,
        option1_price: optionPrice1,
        option2_name: "Mounting Bracket",
        option2_value: selectedItem["Mounting Bracket"],
        option2_price: selectedItem["Mounting Bracket_price"],
        option3_name: optionName3,
        option3_value: optionValue3,
        option3_price: optionPrice3,
        option4_name: "MicroSD Card for Edge Recording",
        option4_value: selectedItem["MicroSD Card for Edge Recording"],
        option4_price: selectedItem["MicroSD Card for Edge Recording_price"],
        option5_name: "Power Adapter",
        option5_value: selectedItem["Power Adapter"],
        option5_price: selectedItem["Power Adapter_price"],
        option6_name: "Audio",
        option6_value: selectedItem["Audio"],
        option6_price: selectedItem["Audio_price"],
      };

      if (selectedItem.drop) {
        newItem = { ...newItem, drop: selectedItem.drop };
      }
      csvCamera.push(newItem);
    });

    const csvCabling = [];
    cabling.map((selectedItem) => {
      let itemTotalPrice =
        selectedItem.totalPriceForItem * selectedItem.quantity;
      let itemOptionPrice =
        selectedItem.quantity * selectedItem["Cable Color_price"];
      let final = itemTotalPrice + itemOptionPrice;
      let newItem = {
        option: selectedItem.num_options,
        page: "cabling",
        category: "Cabling",
        Product_Name: getProductSku(selectedItem),
        Name: getProductDisplayName(selectedItem),
        cableColor: selectedItem["Cable Color"],
        cableColorPrice: selectedItem["Cable Color_price"],
        Product_Quantity: selectedItem.quantity,
        Product_Base_Price: selectedItem.pricePerItem,
        // Product_Final_Price:
        //   selectedItem.totalPriceForItem * selectedItem.quantity,
        Product_Final_Price: final,
        image:
          selectedItem?.thumbnail ||
          selectedItem?.image1 ||
          selectedItem?.image2 ||
          selectedItem?.image3 ||
          "",
      };

      addOptionSlots(newItem, selectedItem);

      if (selectedItem.drop) {
        newItem = { ...newItem, drop: selectedItem.drop };
      }

      csvCabling.push(newItem);
    });

    const csvLabor = [];
    labor.map((selectedItem) => {
      let newItem = {
        option: selectedItem.num_options,
        page: "labor",
        category: "Labor",
        Product_Name: getProductSku(selectedItem),
        Name: getProductDisplayName(selectedItem),
        image:
          selectedItem?.thumbnail ||
          selectedItem?.image1 ||
          selectedItem?.image2 ||
          selectedItem?.image3 ||
          "",
        Product_Quantity: selectedItem.quantity,
        Product_Base_Price: selectedItem.pricePerItem,
        Product_Final_Price:
          selectedItem.totalPriceForItem * selectedItem.quantity,
      };

      addOptionSlots(newItem, selectedItem);

      if (selectedItem.drop) {
        newItem = { ...newItem, drop: selectedItem.drop };
      }

      csvLabor.push(newItem);
    });

    const csvPoe = [];
    poe.map((selectedItem) => {
      let newItem = {
        num_poe_ports: selectedItem.Extra_Field,
        option: selectedItem.num_options,
        page: "poe-switch",
        category: "Poe",
        image:
          selectedItem?.thumbnail ||
          selectedItem?.image1 ||
          selectedItem?.image2 ||
          selectedItem?.image3 ||
          "",
        Product_Name: getProductSku(selectedItem),
        Name: getProductDisplayName(selectedItem),
        Product_Quantity: selectedItem.Port_Quantity,
        Product_Base_Price: selectedItem.Port_Base_Price,
        Product_Final_Price:
          selectedItem.poeFinalPrice * selectedItem.Port_Quantity,
        description: selectedItem.description || "",
      };

      addOptionSlots(newItem, selectedItem);

      if (selectedItem.drop) {
        newItem = { ...newItem, drop: selectedItem.drop };
      }

      csvPoe.push(newItem);
    });

    const csvSpecial = [];
    special.map((selectedItem) => {
      let newItem = {
        option: selectedItem.num_options,
        page: "special",
        category: "Special",
        Product_Name: getProductSku(selectedItem),
        Name: getProductDisplayName(selectedItem),
        Product_Quantity: selectedItem.Camera_Quantity,
        Product_Base_Price: selectedItem.Camera_Base_Price,
        Product_Final_Price:
          selectedItem.Camera_Final_Price * selectedItem.Camera_Quantity,
        image:
          selectedItem?.thumbnail ||
          selectedItem?.image1 ||
          selectedItem?.image2 ||
          selectedItem?.image3 ||
          "",
      };

      addOptionSlots(newItem, selectedItem);

      if (selectedItem.drop) {
        newItem = { ...newItem, drop: selectedItem.drop };
      }

      csvSpecial.push(newItem);
    });

    const csvNewHardware = [];
    if (newHardware && Array.isArray(newHardware) && newHardware.length > 0) {
      newHardware.forEach((selectedItem) => {
        // console.log("selectedItem", selectedItem)
        if (selectedItem && typeof selectedItem === "object") {
          let newItem = {
            option: selectedItem.num_options,
            page: "hardware",
            category: "Hardware",
            image:
              selectedItem?.Hardware_Total_data?.thumbnail ||
              selectedItem?.Hardware_Total_data?.image1 ||
              selectedItem?.Hardware_Total_data?.image2 ||
              selectedItem?.Hardware_Total_data?.image3 ||
              "",
            Product_Name: getProductSku(selectedItem),
            Name: getProductDisplayName(selectedItem),
            Product_Quantity: selectedItem.Product_Quantity,
            Product_Base_Price: selectedItem.HardWare_Base_Price,
            Product_Final_Price:
              parseFloat(selectedItem.basePrice3) *
              selectedItem.Product_Quantity,
          };

          addOptionSlots(newItem, selectedItem);

          if (selectedItem.drop) {
            newItem = { ...newItem, drop: selectedItem.drop };
          }
          csvNewHardware.push(newItem);
        }
      });
    }

    let combinedData = [
      ...filteredNvr2,
      ...csvCamera,
      ...csvCabling,
      ...csvLabor,
      ...csvPoe,
      ...csvSpecial,
      ...csvNewHardware,
    ];

    if (whichOption == "") {
      for (let i = 0; i < combinedData.length; i++) {
        combinedData[i] = { option: NumberOfOptions, ...combinedData[i] };
      }
    }
    combinedData.sort((a, b) => parseInt(a.option) - parseInt(b.option));

    return (
      <WrappedComponent
        combinedData={combinedData}
        NumberOfOptions={NumberOfOptions}
        whichOption={whichOption}
        Nvr={Nvr}
        camera={camera}
        cabling={cabling}
        labor={labor}
        poe={poe}
        hard={hard}
        special={special}
        {...props}
      />
    );
  };
};

export default HigherOrderComponent;
